function NotFound() {
  return (
    <div className="h-screen w-screen bg-gray-200 flex items-center justify-center text-black font-[400]">
      Илэрц олдсонгүй.
      <i className="bi bi-exclamation-circle ml-2"></i>
    </div>
  );
}

export default NotFound;
